<template>
  <header 
    class="flex items-center text-xl p-5 w-full text-naranja fixed z-1000 justify-end" 
  >
    <div 
      v-if="!menuVisibility"
      class=" rounded-full p-5 px-6 text-center mr-2 bg-transparent"      
    >
      <!-- :class="[isEncuentro ? 'bg-azulOscuro' : 'bg-transparent']"--> 
      <!-- TODO: color del header en articulos y proyectos -->
      <font-icon 
        height="40px"
        class="icono-menu cursor-pointer text-xs text-amarillo hover:text-naranja"
        icon="bars"
        @click="toggleMenu" 
      />
    </div>
    <!-- <h1 v-if="!isHome">
      <router-link       
        :to="{name: 'inicio'}"        
        class="text-2xl hover:text-header-hovertext active:text-white visited:text-white "
        :style="[ styleColorObject ]"
      >
        <base-icon 
          icon-name="logo" 
          icon-color="var(--headerFontColor)"
          view-box="-600 0 4000 894.06" 
          width="100%" 
          height="8rem" 
          text-color="var(--headerFontColor)"
        >
          <icon-logo />
        </base-icon>
      </router-link>      
    </h1>
    <font-icon 
      v-if="false"
      class=" text-2xl cursor-pointer mr-4 hover:text-header-hovertext "
      icon="search"
    /> -->
  </header>
</template>

<script>
import isPage from '@/mixins/isPageMixin.js';

export default {
  components: {

  },
  mixins: [isPage],
  data() {
    return {
      styleColorObject: { '--colorTitulo': '#fff' }
    }
  },
  computed: {
    menuVisibility() {
      return this.$store.getters.getVisibilityMenu
    },
    // setAlign() {
    //   if (this.menuVisibility) {
    //     return "justify-end"
    //   } else {
    //     return "justify-end"
    //   }
    // },
    // url() {
    //   return this.$store.getters.getdominio
    // },
    // isHome() {
    //   if (this.$route.path == '/' || this.$route.path == this.url ) {
    //     return true    
    //   }
    //   return false
    // },
    // path(){
    //   return this.$route.path
    // },
    // currentPage() {
    //   console.log(this.$route.path)
    //   if (this.$route.path.includes("/experiencias")) {
    //     return {
    //       title: 'Experiencias Lúdicas',
    //       namePath: 'experiencias'
    //     } 
    //   }   
    //   if (this.$route.path.includes("/juegos")) {
    //     return {
    //       title: 'Biblioteca de Juegos',
    //       namePath: 'cosoteca'
    //     }  
    //   } 
    //   if (this.$route.path.includes("/dispositivos")) {
    //     return {
    //       title: 'Dispositivos Lúdicos',
    //       namePath: 'dispositivos'
    //     } 
    //   }   
    //   if (this.$route.path.includes("/nosotrxs")) { 
    //     return {
    //       title: 'Nosotrxs',
    //       namePath: 'nosotrxs'
    //     } 
    //   }
    //   if (this.$route.path.includes("/contacto")) { 
    //     return {
    //       title: 'Contacto',
    //       namePath: 'contacto'
    //     } 
    //   }
    //   if (this.$route.path.includes("/novedades")) {
    //     return {
    //       title: 'Novedades',
    //       namePath: 'novedades'
    //     } 
    //   }
    //   return 'otros' 
    // },
    // isEncuentro(){
    //   if (this.$route.path.includes("/encuentro")) {
    //     return true
    //   } else {
    //     return false
    //   }
    // }, 
  },
  created() {
  },
  methods: {
    toggleMenu() {
      this.$store.dispatch("changeMenu")
    },
  },
}
</script>

<style scoped>

  .icono-menu {
    height: 40px !important;
  }

  /* .cls-2 {
    fill: var(--headerFontColor);
  }
  .cls-3 {
    font-size:229.4px;
    fill:var(--colorTitulo);
    font-family:PotatoesAndPeasRegular, Potatoes And Peas
  } */


</style>
